import { Icons } from '@packages/webshop-design-system';
import type { ReactNode } from 'react';
import { toast, type ToastOptions } from 'react-toastify';

export const toastSuccess = (
  message: ReactNode | string,
  options: ToastOptions = {}
) => toast.success(message, { ...options, icon: <Icons.checkCircle /> });

export const toastWarning = (
  message: ReactNode | string,
  options: ToastOptions = {}
) => toast.warning(message, { ...options, icon: <Icons.alertCircle /> });

export const toastError = (
  message: ReactNode | string,
  options: ToastOptions = {}
) =>
  toast.error(message, {
    ...options,
    icon: <Icons.alertCircle />,
  });

export const toastInfo = (
  message: ReactNode | string,
  options: ToastOptions = {}
) => toast.info(message, { ...options, icon: <Icons.alertCircle /> });
